<template>
  <h4>We understand price is always important</h4>
  <p>
    We pride ourselves in offering competitive tariffs and we'd like to learn
    and improve from your experience. Please tell us a bit more before we cancel
    your switch.
  </p>
</template>
